/*
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, {
  Lazyload
} from 'vant'
import {
  ImagePreview
} from 'vant';
import native from '../src/lib/native'

// 全局注册
Vue.use(ImagePreview);
import 'vant/lib/index.css'
import http from '../src/lib/http'
import comm from '../src/lib/common'
import api from '../src/lib/api'
import constant from '../src/lib/constant'
// import echarts from 'echarts'
import '@/assets/css/index.less'
import '@/assets/font-app/iconfont.css'
import '@/assets/font-app/iconfont.js'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
// import moment from 'moment'
import moment from 'moment'

Vue.use(Vant)
Vue.use(Lazyload)
Vue.config.productionTip = false // 阻止启动生产消息，常用作指令。

Vue.prototype.$moment = moment; //赋值使用
Vue.prototype.$http = http
Vue.prototype.$comm = comm
Vue.prototype.$api = api
Vue.prototype.$loading = comm.loading
Vue.prototype.$clear = comm.clear
Vue.prototype.$topBar = false
// Vue.prototype.$echarts = echarts 
Vue.prototype.$trigger = "onBlur"
Vue.prototype.$patternId = /^[1-9]\d{7}((0\d)|bai(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
Vue.prototype.$pattern = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,2,3,4,5,6,7,8,9]|8[0-9]|9[1,5,8,9])\d{8}$/
Vue.prototype.$patternEmail = /^\s*$|^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
Vue.prototype.$tel = /^(8\d{7})|(1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8})$/
Vue.prototype.$minDate = new Date(2020, 0, 1)
Vue.prototype.$maxDate = new Date(2025, 10, 1)
Vue.prototype.$currentDate = new Date()
Vue.prototype.$debugStart = process.env.NODE_ENV == 'development' ? true : false;
Vue.prototype.$idcardmsg = '用户名称与联系人不一致、请上传联系人身份证'
Vue.prototype.$idenfile = "请上传身份证证件"
Vue.prototype.$certfile = "请上传房屋产权证"
Vue.prototype.$lxdfile = "申请表"


Vue.prototype.$native = native
Vue.prototype.$constant = constant
Vue.prototype.$typeList = [{
  code: '206',
  formPath: '/butler/breakdown/form',
},
{
  code: '207',
  formPath: '/butler/advice/form',
},
{
  code: '208',
  formPath: '/butler/leak/form',
},
{
  code: '209',
  formPath: '/butler/monitor/form',
},
{
  code: '210',
  formPath: '/butler/read/form',
},
{
  code: '211',
  formPath: '/butler/paysewage/Form',
},
{
  code: '407',
  formPath: '/business/checkForm',
},
{
  code: '401',
  formPath: '/meterTransferForm',
},
{
  code: '402',
  formPath: '/business/catchForm',
},
{
  code: '403',
  formPath: '/business/remodelForm',
},
{
  code: '404',
  formPath: '/business/changeForm',
},
{
  code: '405',
  formPath: '/business/reconnectForm',
},
{
  code: '406',
  formPath: '/business/destroyForm',
},
{
  code: '408',
  formPath: '/business/stopForm',
},
{
  code: '409',
  formPath: '/business/natureForm',
},
{
  code: '501',
  formPath: '/company/changeWaterMasterForm',
},
{
  code: '502',
  formPath: '/company/catchWaterForm',
},
{
  code: '503',
  formPath: '/company/connectWaterForm',
},
{
  code: '504',
  formPath: '/company/destroyWaterForm',
},
{
  code: '505',
  formPath: '/company/changeWaterNatureForm',
},
{
  code: '506',
  formPath: '/company/applyTaxForm',
},
{
  code: '507',
  formPath: '/company/changeTaxForm',
},
{
  code: '508',
  formPath: '/company/returnTaxForm',
},
{
  code: '509',
  formPath: '/company/remoldWaterForm',
},
{
  code: '510',
  formPath: '/company/movePipeForm',
},
{
  code: '511',
  formPath: '/company/peopleWaterForm',
},
{
  code: '512',
  formPath: '/company/moveWaterForm',
},
{
  code: '513',
  formPath: '/company/unInvokeProForm',
},
{
  code: '514',
  formPath: '/company/buildProForm',
},
{
  code: '515',
  formPath: '/company/changeWaterForm',
}
],
  Vue.prototype.$menuDict = {
    '过户申请': {
      path: '/meterTransferForm',
      typeCode: '401'
    },
    '新户报装': {
      path: '/business/catchForm',
      typeCode: '402'
    },
    '退费申请': {
      path: '/business/remodelForm',
      typeCode: '403'
    },
    '客户信息变更': {
      path: '/business/changeForm',
      typeCode: '404'
    },
    '报停复水申请': {
      path: '/business/reconnectForm',
      typeCode: '405'
    },
    '销户申请': {
      path: '/business/destroyForm',
      typeCode: '406'
    },
    '检表申请': {
      path: '/business/checkForm',
      typeCode: '407'
    },
    '报停申请': {
      path: '/business/stopForm',
      typeCode: '408'
    },
    '用水性质变更': {
      path: '/business/natureForm',
      typeCode: '409'
    },
    '故障报修': {
      path: '/butler/breakdown/form',
      typeCode: '206'
    },
    '投诉建议': {
      path: '/butler/advice/form',
      typeCode: '207'
    },
    '表后设施检漏申请': {
      path: '/butler/leak/form',
      typeCode: '208'
    },
    '水质检测申请': {
      path: '/butler/monitor/form',
      typeCode: '209'
    },
    '网上抄表': {
      path: '/butler/read/form',
      typeCode: '210'
    },
    '非居民污水处理费缓交申请': {
      path: '/butler/paysewage/form',
      typeCode: '211'
    },
    '单位水表过户': {
      path: '/company/changeWaterMasterForm',
      typeCode: '501'
    },
    '单位报停复水申请': {
      path: '/company/connectWaterForm',
      typeCode: '503'
    },
    '单位销户申请': {
      path: '/company/destroyWaterForm',
      typeCode: '504'
    },
    '单位报停申请': {
      path: '/company/catchWaterForm',
      typeCode: '502'
    },
    '单位用水性质变更': {
      path: '/company/changeWaterNatureForm',
      typeCode: '505'
    },
    '增值税专票申请': {
      path: '/company/applyTaxForm',
      typeCode: '506'
    },
    '增值税信息变更': {
      path: '/company/changeTaxForm',
      typeCode: '507'
    },
    '增值税专票撤销': {
      path: '/company/returnTaxForm',
      typeCode: '508'
    },
    '单位退费申请': {
      path: '/company/remoldWaterForm',
      typeCode: '509'
    },
    '单位检表申请': {
      path: '/company/movePipeForm',
      typeCode: '510'
    },
    '单位新户报装': {
      path: '/company/peopleWaterForm',
      typeCode: '511'
    },
    '水表移位工程': {
      path: '/company/moveWaterForm',
      typeCode: '512'
    },
    '不涉及工程项目报装': {
      path: '/company/unInvokeProForm',
      typeCode: '513'
    },
    '新建及改扩建,基建接水项目用水报装': {
      path: '/company/buildProForm',
      typeCode: '514'
    },
    '单位水表变更': {
      path: '/company/changeWaterForm',
      typeCode: '515'
    }
  }

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$imgBaseUrl = 'http://localhost:14690/';
} else {
  Vue.prototype.$imgBaseUrl = '';
}

//本地调试微信公众号开发
if (Vue.prototype.$debugStart) {
  let access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NjczNzk2OTYuMCwiZXhwIjoxNjY3NDE1Njk2LjAsInNvdXJjZSI6MSwidWlkIjo0NiwicmVsYXRpb25pZCI6IjAiLCJ1bmFtZSI6Iui1teaYjuW5syIsIm1vYmlsZSI6IjE4ODcxNDc3MjcyIiwidXNlcmluZm8iOnsic291cmNlIjoxLCJ1aWQiOjQ2LCJ1bmFtZSI6Iui1teaYjuW5syIsIm1vYmlsZSI6IjE4ODcxNDc3MjcyIiwibmlja25hbWUiOiLljL_lkI3nlKjmiLciLCJhdmF0YXIiOiIiLCJvcGVuaWQiOm51bGwsInJlbGF0aW9uSWQiOiIwIiwiYWxsSWQiOm51bGx9fQ.BQYFNqePyZhqoLhChEOXhQwy6TBCcZ9yV9ru8PIF-bY"
  let refresh_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NjczNzk2OTYuMCwiZXhwIjoxNjY3NDM5Njk2LjAsInNvdXJjZSI6MSwidWlkIjo0NiwicmVsYXRpb25pZCI6IjAiLCJ1bmFtZSI6Iui1teaYjuW5syIsIm1vYmlsZSI6IjE4ODcxNDc3MjcyIiwidXNlcmluZm8iOnsic291cmNlIjoxLCJ1aWQiOjQ2LCJ1bmFtZSI6Iui1teaYjuW5syIsIm1vYmlsZSI6IjE4ODcxNDc3MjcyIiwibmlja25hbWUiOiLljL_lkI3nlKjmiLciLCJhdmF0YXIiOiIiLCJvcGVuaWQiOm51bGwsInJlbGF0aW9uSWQiOiIwIiwiYWxsSWQiOm51bGx9fQ.gvIaBWqRuGKBtHJmoIRDAFetuZYoC-_zhpJaYVIxpjI"
  localStorage.setItem('access_token', access_token)
  localStorage.setItem('refresh_token', refresh_token)
  localStorage.setItem('nickname', '小明同学')
  localStorage.setItem('avatar', require('./assets/images/default.png'))
  let cuser_info = {
    uname: '小明同学',
    mobile: '18871477272'
  }
  if (localStorage.getItem('cuser_info')) {
    cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
  }
  localStorage.setItem('cuser_info', JSON.stringify(cuser_info))
}


//特殊判断
let cuser_info = null;
if (localStorage.getItem('cuser_info')) {
  cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
}

if (cuser_info != null) {
  var tel = cuser_info ? cuser_info.mobile : ''; // 电话
  var flag = 0
  if (tel == "18321264398" || tel == "18357502925") {
    flag = 1;
  }
  localStorage.setItem('mobile', flag)
}


/*
  存储已绑定的用户列表
*/
http.post(api.userList, {}).then(res => {
  if (res.code === '000') {
    if (res.data != null && res.data.length > 0) { // 已绑定
      store.commit('updateUserList', res.data)
      localStorage.setItem('userList', JSON.stringify(res.data))
    }
  }
})

/*
  存储业务类型列表 个人业务和单位业务
*/
http.post(api.getBusinessTypes, {
  busstype: '0', // 4-个人业务 5- 单位业务
}).then(res => {
  if (res.code === '000') {
    if (res.data.length > 0) {
      let typeList = [{
        typename: '全部',
        typecode: ''
      }]
      typeList.push.apply(typeList, res.data);
      store.commit('updateBussTypeList', typeList)
    }
  }
})

/*
  存储业务类型列表 单位业务
*/
http.post(api.getBusinessTypes, {
  bigcode: 5, // 4-个人业务 2-水管家 5-单位业务
}).then(res => {
  if (res.code === '000') {
    if (res.data.length > 0) {
      let typeList = [{
        typename: '全部',
        typecode: ''
      }]
      typeList.push.apply(typeList, res.data);
      store.commit('updateCompanyTypeList', typeList)
    }
  }
})

/*
  存储业务类型列表 水管家
*/
http.post(api.getBusinessTypes, {
  bigcode: 2, // 4-个人业务 2-水管家
}).then(res => {
  if (res.code === '000') {
    if (res.data.length > 0) {
      let typeList = [{
        typename: '全部',
        typecode: ''
      }]
      typeList.push.apply(typeList, res.data);
      store.commit('updateButlerTypeList', typeList)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')